export const formatNumber = (value) => {

  if (value === null || value === undefined || value === "") {
      return "";
  }

  const clean = normalizeNumber(value);

  return clean.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

};

export const unformatNumber = (value) => {

  if (!value) return "";

  return value.toString().replace(/,/g, "");

};
  
export const normalizeNumber = (value) => {

  if (!value) return "";

  return value

  .toString()

  .replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))

  .replace(/[٠-٩]/g, d => "٠١٢٣٤٥٦٧٨٩".indexOf(d))

  .replace(/,/g, "")

  .replace(/٬/g, "");

};